import type { MouseEvent } from 'react';
import { FacebookIcon } from './Icons';

// The Facebook link of a tournament, a team or a person. Every page shows it
// with one look: the pill of the tournament card (operator, 2026-10-08). The
// team page and the profile had a blue text link with a smaller icon.
// `facebook-pill.spec.ts` checks that each Facebook link uses this component.

interface FacebookPillProps {
  url: string;
  testId?: string;
  /** The tournament card stops the click: the card is a link too. */
  onClick?: (e: MouseEvent) => void;
  className?: string;
}

export function FacebookPill({ url, testId, onClick, className = '' }: FacebookPillProps) {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" data-testid={testId} onClick={onClick}
      className={`badge gap-1 bg-blue-50 text-blue-600 ring-1 ring-inset ring-blue-200 hover:bg-blue-100 ${className}`}>
      <FacebookIcon className="w-3.5 h-3.5" /> Facebook
    </a>
  );
}
